<app-loader *ngIf="loading$ | async"></app-loader>
<router-outlet></router-outlet>
